import type { WorkspaceAccess } from "../lib/access";
import { Spinner } from "./Spinner";

interface WorkspaceProblemProps {
  access: Extract<WorkspaceAccess, { kind: "revoked" | "unavailable" }>;
  signInHref: string;
  onRetry: () => void;
  retrying: boolean;
}

export function WorkspaceProblem({ access, signInHref, onRetry, retrying }: WorkspaceProblemProps) {
  let content;
  if (access.kind === "revoked" && access.failure === "signed-out") {
    content = (
      <>
        <h1>Sign in to keep going</h1>
        <p>Your session has ended. Sign in again and you’ll come straight back to your website.</p>
        <a className="bw-btn bw-btn--primary" href={signInHref}>Sign in</a>
      </>
    );
  } else if (access.kind === "revoked") {
    content = (
      <>
        <h1>This website isn’t available</h1>
        <p>It may have been removed, or it belongs to a different account.</p>
        <a className="bw-btn bw-btn--quiet" href="/">Go to your dashboard</a>
      </>
    );
  } else {
    content = (
      <>
        <h1>StackJe can’t be reached</h1>
        <p>Your work is saved. Check your connection, then try again.</p>
        <button type="button" className="bw-btn bw-btn--primary" onClick={onRetry} disabled={retrying}>
          {retrying && <Spinner />}
          {retrying ? "Trying…" : "Try again"}
        </button>
      </>
    );
  }
  return (
    <main className="bw-full">
      <div className="bw-full-card" role={access.kind === "unavailable" ? "alert" : undefined}>{content}</div>
    </main>
  );
}
